import { createAPI } from '@common'
export default {
  getMamFastEditUrl: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0gbtu0feju0vsm', 'GET', config),
  getMamFastEditLogout: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0gbtu0feju0mphpvu', 'GET', config)
}
